(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-gateway"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseGatewayVideos = (scope = document) => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const saveData = Boolean(navigator.connection && navigator.connection.saveData);

      scope.querySelectorAll('[data-brand-gateway-video]').forEach((video) => {
        if (video.dataset.gatewayVideoInitialised === 'true') return;
        video.dataset.gatewayVideoInitialised = 'true';

        if (reduceMotion || saveData) {
          video.pause();
          return;
        }

        const revealVideo = () => video.classList.add('is-ready');
        if (video.readyState >= 2) {
          revealVideo();
        } else {
          video.addEventListener('loadeddata', revealVideo, { once: true });
        }

        video.preload = 'metadata';
        video.load();
        const playAttempt = video.play();
        if (playAttempt) playAttempt.catch(() => {});
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseGatewayVideos(), { once: true });
    } else {
      initialiseGatewayVideos();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseGatewayVideos(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialiseHeroVideo = (hero) => {
      if (!(hero instanceof Element)) return;

      const video = hero.querySelector('[data-brand-hero-video]');
      const control = hero.querySelector('[data-brand-hero-video-control]');
      if (!video || !control || video.dataset.heroVideoInitialised === 'true') return;

      video.dataset.heroVideoInitialised = 'true';
      const saveData = Boolean(navigator.connection && navigator.connection.saveData);
      if (reducedMotion.matches || saveData) {
        video.pause();
        return;
      }

      let pausedByUser = false;
      let inViewport = true;

      const setControlState = (paused) => {
        control.setAttribute('aria-pressed', paused ? 'true' : 'false');
        control.setAttribute('aria-label', paused ? control.dataset.playLabel : control.dataset.pauseLabel);
      };

      const play = () => {
        if (pausedByUser || !inViewport || document.hidden) return;
        const playAttempt = video.play();
        if (playAttempt) {
          playAttempt
            .then(() => {
              video.classList.add('is-ready');
              control.hidden = false;
              setControlState(false);
            })
            .catch(() => {
              video.classList.remove('is-ready');
              control.hidden = true;
            });
        }
      };

      control.addEventListener('click', () => {
        pausedByUser = !video.paused;
        if (pausedByUser) {
          video.pause();
          setControlState(true);
        } else {
          play();
        }
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          inViewport = entries[0]?.isIntersecting ?? false;
          if (inViewport) play();
          else video.pause();
        });
        observer.observe(hero);
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else play();
      });

      video.preload = 'metadata';
      video.load();
      play();
    };

    const initialiseHeroVideos = (scope = document) => {
      if (scope.matches?.('.brand-hero')) initialiseHeroVideo(scope);
      scope.querySelectorAll?.('.brand-hero').forEach(initialiseHeroVideo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseHeroVideos(), { once: true });
    } else {
      initialiseHeroVideos();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseHeroVideos(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
